import { type FC } from 'react'
import { useOrionContactSync } from '../IntegrationSpecificSettings/Orion/hooks'
import { type CrmIntegrationSettings, type CrmSettingsProviderProps } from './types'

export const OrionCrmSettingsProvider: FC<CrmSettingsProviderProps> = ({ children }) => {
  const contact = useOrionContactSync()

  const settings: CrmIntegrationSettings = {
    contactSync: contact.autoSync,
    calendarSync: false,
    isSyncDisabled: false,
    isFetching: contact.isFetching,
    isSaving: contact.isSaving,
    save: async (patch) => {
      if (patch.contactSync !== undefined) {
        await contact.saveAutoSync(patch.contactSync)
      }
    },
  }

  return <>{children(settings)}</>
}
